<template>
  <DefaultLayout>
    <HomePage/>
  </DefaultLayout>
</template>

<script>
import { provide } from 'vue';
import MobileDetectionHook from '@/hooks/mobileDetection.hook';
import DefaultLayout from '@/layouts/Default.layout.vue';
import HomePage from '@/pages/homePage/HomePage.page.vue';

export default {
  name: 'App',
  components: {
    DefaultLayout,
    HomePage,
  },
  setup() {
    MobileDetectionHook();
    const isHeaderMode = true;
    provide('isHeaderMode', isHeaderMode);
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
